import { Disposable } from '@vertexvis/utils';

import { ImageLoadError } from '../errors';

export interface HtmlImage extends Disposable {
  image: HTMLImageElement | ImageBitmap;
}

function asBlobPart(bytes: Uint8Array): ArrayBuffer {
  const copy = new Uint8Array(bytes.byteLength);
  copy.set(bytes);
  return copy.buffer;
}

function loadImageBytesAsImageElement(
  imageData: Uint8Array
): Promise<HtmlImage> {
  return new Promise((resolve, reject) => {
    const blob = new Blob([asBlobPart(imageData)]);
    const blobUrl = URL.createObjectURL(blob);

    const image = new Image();
    image.addEventListener('load', () => {
      resolve({ image, dispose: () => undefined });
      URL.revokeObjectURL(blobUrl);
    });
    image.addEventListener('error', () => {
      reject(new ImageLoadError('Failed to load image data'));
      URL.revokeObjectURL(blobUrl);
    });

    image.src = blobUrl;
  });
}

async function loadImageBytesAsImageBitmap(
  imageData: Uint8Array
): Promise<HtmlImage> {
  const blob = new Blob([asBlobPart(imageData)]);
  const bitmap = await window.createImageBitmap(blob);
  return { image: bitmap, dispose: () => bitmap.close() };
}

export function loadImageBytes(imageBytes: Uint8Array): Promise<HtmlImage> {
  if (window.createImageBitmap != null) {
    return loadImageBytesAsImageBitmap(imageBytes);
  } else {
    return loadImageBytesAsImageElement(imageBytes);
  }
}
